import { computed, type ComputedRef, type Ref } from 'vue';
import { usePrepareToken } from './useAuth';

interface UseUserLoginReturn {
    /** 是否已登录（响应式） */
    isLoggedIn: ComputedRef<boolean>;
    /** 是否正在检查登录状态 */
    isLoading: Ref<boolean>;
}

/**
 * 响应式登录状态 Composable
 * 基于 prepareToken deferred 实现，自动响应登录状态变化
 */
export function useUserLogin(): UseUserLoginReturn {
    const { value: prepareToken, isLoading } = usePrepareToken();

    const isLoggedIn = computed(() => {
        return !!prepareToken.value;
    });

    return {
        isLoggedIn,
        isLoading,
    };
}
